import React, { useState } from "react";

import PropTypes from "prop-types";
import { Field } from "formik";
import { FormGroupBlock } from "./antd";
import { DatePicker } from "antd";

import { Select } from "antd";

import { selectTimezones } from "../../../core/utils/timezones";
import { Form, Input } from "antd";

import Moment from "moment-timezone";

const styles = {
    control: (base) => ({
        ...base,
        width: 200,
    }),
};

const InputText = (props) => {
    const { defaultTimezone } = props;
    const [locale, setLocale] = useState(defaultTimezone);

    return (
        <FormGroupBlock {...props}>
            <Field name={props.name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { setFieldValue, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => {
                    const setValue = (date, locale) => {
                        if (date) {
                            setFieldValue(field.name, Moment.tz(date.format("YYYY-MM-DD HH:mm:ss"), locale));
                        } else {
                            setFieldValue(field.name, date);
                        }
                    };
                    return (
                        <Input.Group compact>
                            <Form.Item noStyle>
                                <DatePicker
                                    style={{ width: "60%" }}
                                    defaultValue={field.value}
                                    format={props.format ? props.format : "DD/MM/YYYY"}
                                    showTime={props.showTime ? props.showTime : undefined}
                                    onChange={(option) => {
                                        setValue(option, locale);
                                    }}
                                />
                            </Form.Item>

                            <Form.Item noStyle>
                                <Select
                                    className=""
                                    options={selectTimezones()}
                                    style={{ margin: "0 4px", width: "calc(40% - 8px)" }}
                                    showSearch
                                    defaultValue={defaultTimezone}
                                    value={locale}
                                    onChange={(option) => {
                                        setLocale(option);
                                        setValue(field.value, option);
                                    }}
                                />
                            </Form.Item>
                        </Input.Group>
                    );
                }}
            </Field>
        </FormGroupBlock>
    );
};

InputText.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default InputText;
